<template lang="pug">
  .module__main
    .module-content__container
      .filters__container
        .active-status__container
          el-select(v-model="activeMode" @change="loadOrders()")
            el-option(v-for="option in activeOptions" :key="`active-option-${option.key}`" :label="option.locale" :value="option.key")
        .dates__container
          .date__container
            el-date-picker(
              v-model="date"
              type="datetimerange"
              range-separator="-"
              start-placeholder="От"
              end-placeholder="До"
              :picker-options="dateOptions"
            )
        .finish-reason__container(v-if="activeMode === 'finished'")
          el-select(v-model="finishReason" @change="loadOrders()")
            el-option(label="Все" value="all" key="search-finish-reason-all")
            el-option(
              v-for="(reason, value) in finishReasons"
              :key="`search-finish-reason-${value}`"
              :label="reason.description"
              :value="value"
            )
        .search__container
          el-select(v-model="searchMode" @change="updateDefaultSearchMode()")
            el-option(v-for="(mode, key) in searchModes" :key="`search-mode-${key}`" :label="mode.locale" :value="key")
          .search-fiat-amount(v-if="searchMode === 'fiat_amount'")
            el-input(v-model="searchFiatAmount.min" @input="searchOrders" type="number" placeholder="Сумма от" )
            el-input(v-model="searchFiatAmount.max" @input="searchOrders" type="number" placeholder="Сумма до" )
          el-input(v-else v-model="searchValue" @input="searchOrders" :placeholder="searchModes[searchMode].title")
          i.el-icon-close.search-reset__btn(v-if="showResetSearchButton" @click="resetSearch()")
      .table__container
        i.orders-loading-icon.el-icon-loading(v-if="isLoading && !isFirstLoading")
        .table-list__container
          el-table(
            v-loading="isLoading && isFirstLoading"
            :data="formattedOrders"
            style="width: 100%; font-size: 12px"
            :row-class-name="tableRowClassName"
          )
            el-table-column(label="ID" width="100")
              template(slot-scope="scope")
                .order-id__container(@click="copyIdInfo(scope.row)")
                  .val {{ scope.row.id }}
                  .val(
                    v-if="scope.row.deal_id"
                    :style="scope.row.handler && handlersColors[scope.row.handler] ? `color: ${handlersColors[scope.row.handler]}` : ''"
                  )
                    span {{ scope.row.deal_id }}
                    span(v-if="scope.row.handler") {{ ` (${scope.row.handler})` }}
            el-table-column(prop="payment_system" label="Направление" width="100")
              template(slot-scope="scope")
                .val {{ `${scope.row.payment_system}` }}
            el-table-column(prop="fiat_amount" label="Фиат" width="100")
            el-table-column(label="Крипто" width="180")
              template(slot-scope="scope")
                .crypto-amount(v-if="isAdmin")
                  .val
                    span.col-title Обменка:
                    span {{ scope.row.crypto_amount }} {{ scope.row.crypto_type }}
                  .val(v-if="scope.row.crypto_amount_deal")
                    span.col-title Сделка:
                    span {{ scope.row.crypto_amount_deal }} {{ scope.row.crypto_type }}
                  .val(v-if="scope.row.crypto_amount_deal && scope.row.crypto_type !== scope.row.crypto_type_deal")
                    span ({{ scope.row.crypto_amount_deal_original }} {{ scope.row.crypto_type_deal }})
                .val.mt5
                  span.col-title Кошелек:
                  span.cursor-pointer(@click="copyTextToClipboard(scope.row.tx_address, 'Кошелек скопирован')") {{ scope.row.tx_address }}
            el-table-column(v-if="isAdmin" label="Курс" width="160")
              template(slot-scope="scope")
                .rate-amount
                  .val
                    span.col-title Обменка:
                    span {{ scope.row.rate }}
                  .val(v-if="scope.row.rate_deal")
                    span.col-title Сделка:
                    span {{ scope.row.rate_deal }}
                  .val(v-if="scope.row.rate_deal && scope.row.crypto_type !== scope.row.crypto_type_deal")
                    span ({{ scope.row.rate_deal_original }})
            el-table-column(v-if="isAdmin" label="Прибыль" width="160")
              template(slot-scope="scope")
                .rate-amount {{ scope.row.crypto_profit }} {{ scope.row.crypto_type }}
            el-table-column(prop="status" label="Статус" width="170")
              template(slot-scope="scope")
                .val {{ statuses[scope.row.status] || scope.row.status }}
                .val(v-if="scope.row.finished_by && scope.row.finished_by !== 'system'") {{ `(${scope.row.finished_by})` }}
                .val(v-if="scope.row.finish_reason") {{ `(${ finishReasons[scope.row.finish_reason] ? finishReasons[scope.row.finish_reason].description : scope.row.finish_reason })` }}
                .val(v-if="(scope.row.status === 'canceled' || scope.row.status === 'cancel_error') && scope.row.cancel_reason") {{ `(${scope.row.cancel_reason})` }}
                .val(v-if="scope.row.status === 'error' && scope.row.error_reason") {{ `(${scope.row.error_reason})` }}
                .val(v-if="scope.row.claim") {{ `Открыта ${scope.row.claim.created} на сумму ${scope.row.claim.fiat_amount} р.` }}
                .val(v-if="scope.row.txidLink")
                  span Транзакция:
                  a.ml5(:href="scope.row.txidLink") {{ scope.row.txidLink }}
            el-table-column(prop="requisites" label="Реквизит" width="150")
              template(slot-scope="scope" v-if="scope.row.requisites")
                .val
                  span(:class="{ 'black-list-user': scope.row.isBlacklistRequisite }") {{ scope.row.requisites }}
                  i.order-black-list__btn.el-icon-unlock.color-success(
                    v-if="scope.row.isBlacklistRequisite"
                    @click="changeBlackListStatus(scope.row.requisites, 'delete', 'requisite')"
                  )
                  i.order-black-list__btn.el-icon-lock.color-danger(
                    v-else
                    @click="changeBlackListStatus(scope.row.requisites, 'add', 'requisite')"
                  )
                .val(v-if="scope.row.requisites_bank") {{ scope.row.requisites_bank }}
                .val(v-if="scope.row.requisites_country") {{ scope.row.requisites_country }}
                .val(v-if="scope.row.requisites_recipient") {{ scope.row.requisites_recipient }}
            el-table-column(label="Клиент" width="100")
              template(slot-scope="scope")
                span(:class="{ 'black-list-user': scope.row.isBlacklistUser }")  {{ scope.row.client_name }}
                i.order-black-list__btn.el-icon-unlock.color-success(
                  v-if="scope.row.isBlacklistUser"
                  @click="changeBlackListStatus(scope.row.client_name, 'delete', 'user')"
                )
                i.order-black-list__btn.el-icon-lock.color-danger(
                  v-else
                  @click="changeBlackListStatus(scope.row.client_name, 'add', 'user')"
                )
                .val(v-if="scope.row.client_note")
                  span.client_note {{ `(${scope.row.client_note})` }}
                  i.order-black-list__btn.el-icon-remove-outline.color-danger(@click="startDeleteClientNote(scope.row.client_name)")
                i.order-black-list__btn.el-icon-circle-plus-outline.color-primary(
                  v-else
                  @click="activateAddClientNote(scope.row.client_name)"
                )
            el-table-column(prop="created" label="Создана" width="85")
            el-table-column(label="Пометки" width="95")
              template(slot-scope="scope")
                .notes__container(v-if="scope.row.notes")
                  i.note-icon.el-icon-warning-outline(
                    :class="{ 'color-danger': scope.row.notes.problem }"
                    :title="scope.row.notes.problem ? 'Отмечена проблемной' : 'Отметить проблемной'"
                    @click="handleOrderNote(scope.row, 'problem')"
                  )
                  i.note-icon.el-icon-coin(
                    :class="{ 'color-success': scope.row.notes.paid }"
                    :title="scope.row.notes.problem ? 'Отмечена оплаченной' : 'Отметить оплаченной'"
                    @click="handleOrderNote(scope.row, 'paid')"
                  )
            el-table-column(label="Действия" width="150")
              template(slot-scope="scope")
                .order-action__buttons
                  .action__btn(v-if="scope.row.isCanFinish")
                    el-button(
                      @click="openOrderModifying(scope.row.id, scope.row.fiat_amount, 'finish')"
                      title="Завершить"
                      icon="el-icon-check"
                      type="success"
                      size="mini"
                      circle
                    )
                  .action__btn(v-if="scope.row.isCanClaim")
                    el-button(
                      @click="openOrderModifying(scope.row.id, scope.row.fiat_amount, 'claim')"
                      title="Претензия"
                      icon="el-icon-warning-outline"
                      type="warning"
                      size="mini"
                      circle
                    )
                  .action__btn(v-if="scope.row.isCanCancelClaim")
                    el-button(
                      @click="startCancelClaim(scope.row.id)"
                      title="Отмена претензии"
                      icon="el-icon-circle-close"
                      type="danger"
                      size="mini"
                      circle
                    )
                  .action__btn(v-if="scope.row.isCanCancel")
                    el-button(
                      @click="startCancelOrder(scope.row.id)"
                      title="Отменить"
                      icon="el-icon-close"
                      type="danger"
                      size="mini"
                      circle
                    )
        .table-pagination__container
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='orders.pagination.count',
            :page-size="per_page",
            :current-page='orders.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadOrders',
          )
    el-dialog(:visible.sync="isOrderModifying" :before-close="resetOrderModifying" :title="modifyingOrderTitle" width="50%")
      .modify__container
        .original-amount {{ `Сумма в заявке: ${modifyingOrder.original_amount} р.` }}
        .modify-amount
          .title {{ modifyingOrder.mode === 'finish' ? 'Сумма завершения' : 'Сумма претензии' }}
          el-input(v-model="modifyingOrder.amount" type="number" :disabled="true")
        .finish-reason(v-if="modifyingOrder.mode === 'finish'")
          .finish-reason-param
            .title Причина завершения
            el-select(v-model="modifyingOrder.finish_reason")
              el-option(
                v-for="(reason, value) in finishReasons"
                v-if="reason.availableOption"
                :value="value"
                :label="reason.description"
                :key="`finish_reason_${value}`"
              )
          .finish-reason-param(v-if="modifyingOrder.finish_reason === 'compensation' || modifyingOrder.finish_reason === 'duplicate'")
            .title ID связной заявки
            el-input(v-model="modifyingOrder.compensation_order_id" placeholder="Введите ID связной заявки")
        .finish-reason(v-if="modifyingOrder.mode === 'claim'")
          .title Ссылка на чек
          el-input(v-model="modifyingOrder.attachment_link")
        .requisite-add__buttons
          el-button(
            type="success"
            @click="startModifyOrder()"
          ) {{ modifyingOrder.mode === 'finish' ? 'Завершить заявку' : 'Открыть претензию' }}
          el-button(type="danger" @click="resetOrderModifying()") Отменить
    el-dialog(:visible.sync="isClientNoteAdding" :before-close="resetAddClientNote" title="Заметка пользователя" width="40%")
      .requisite-add__container
        .requisite-add__input
          .title Заметка
          el-input(v-model="clientNote.text" placeholder="Введите заметку")
        .requisite-add__buttons
          el-button(type="success" @click="startAddClientNote()") Сохранить
          el-button(type="danger" @click="resetAddClientNote()") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  CANCEL_CLAIM,
  CANCEL_ORDER,
  EDIT_ORDER,
  FINISH_ORDER,
  LOAD_ORDERS_LIST,
  OPEN_CLAIM,
  REFINISH_ORDER,
  SWITCH_NOTE,
} from '@/store/const/orders';
import {
  ADD_BLACK_LIST_REQUISITE,
  ADD_BLACK_LIST_USER, ADD_USER_NOTE,
  DELETE_BLACK_LIST_REQUISITE,
  DELETE_BLACK_LIST_USER, DELETE_USER_NOTE,
} from '@/store/const/exchange';
import instruments from '../../mixins/instruments';
import OrderDialog from './Dialog';

export default {
  name: 'OrdersList',
  components: {
    OrderDialog,
  },
  mixins: [instruments],
  data() {
    return {
      page: 1,
      per_page: 50,
      activeOptions: [
        { key: 'all', locale: 'Все' },
        { key: 'active', locale: 'Активные' },
        { key: 'finished', locale: 'Завершенные' },
        { key: 'attention', locale: 'Требуют внимания' },
        { key: 'canceled', locale: 'Отмененные' },
      ],
      activeMode: 'all',
      searchModes: {
        id: { locale: 'ID обменки', title: 'ID заявки' },
        client_name: { locale: 'По клиенту', title: 'Имя пользователя' },
        requisites: { locale: 'По реквизитам', title: 'Реквизиты' },
        requisites_parted: { locale: 'По части реквизитов', title: 'Цифры' },
        requisites_last_digits: { locale: 'По последним 4 цифрам', title: 'Цифры' },
        deal_id: { locale: 'По сделке', title: 'ID сделки' },
        fiat_amount: { locale: 'По сумме заявки', title: 'ID сделки' },
      },
      searchMode: localStorage.getItem('orders_searchMode') || 'id',
      searchValue: '',
      searchFiatAmount: { min: '', max: '' },
      searchInputLastActivatingTime: 0,
      searchInputLoadDelay: 1000,
      finishAvailableStatuses: [
        'created',
        'canceled',
        'claim',
      ],
      claimAvailableStatuses: [
        'created',
        'canceled',
      ],
      cancelAvailableStatuses: [
        'created',
      ],
      intervalHandle: null,
      isFirstLoading: true,
      isOrderModifying: false,
      modifyingOrder: {
        mode: '',
        id: null,
        amount: null,
        original_amount: null,
        finish_reason: '',
        compensation_order_id: null,
        attachment_link: '',
      },
      finishReason: 'all',
      date: '',
      dateOptions: {
        shortcuts: [
          {
            text: 'Сегодня',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Сутки',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Вчера',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - 1);
              start.setHours(0, 0, 0, 0);
              end.setDate(end.getDate() - 1);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Неделя',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Месяц',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '3 месяца',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      openDialog: {
        id: null,
        deal_id: '',
        status: '',
        client_name: '',
        handler: '',
        fiat_amount: null,
        requisites: '',
        isCanFinish: false,
        isCanClaim: false,
        isCanCancelClaim: false,
        isCanCancel: false,
      },
      clientNote: {
        user: '',
        text: '',
      },
    };
  },
  async mounted() {
    await this.loadOrders();
    this.isFirstLoading = false;
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('orders', ['orders', 'finishReasons']),
    ...mapGetters('user', ['isAdmin', 'isSupport', 'username']),
    ...mapGetters('settings', ['statuses', 'paymentSystems', 'handlersColors']),
    isLoading() {
      return this.loading(LOAD_ORDERS_LIST) === 'loading';
    },
    hasPagination() {
      return this.orders.pagination.count > this.per_page;
    },
    modifyingOrderTitle() {
      return this.modifyingOrder.mode === 'finish'
          ? `Завершение заявки ${this.modifyingOrder.id}`
          : `Открытие претензии по заявке ${this.modifyingOrder.id}`;
    },
    dates() {
      if (Array.isArray(this.date)) {
        const from = new Date(this.date[0]);
        const to = new Date(this.date[1]);
        from.setMinutes(from.getMinutes() - from.getTimezoneOffset()); // SET TO UTC 0
        to.setMinutes(to.getMinutes() - to.getTimezoneOffset()); // SET TO UTC 0
        from.setMinutes(from.getMinutes() - 180); // SET TO UTC +3
        to.setMinutes(to.getMinutes() - 180); // SET TO UTC +3
        return {
          from: from.getTime(),
          to: to.getTime(),
        };
      } else {
        return null;
      }
    },
    formattedOrders() {
      return this.orders.orders.map((order) => {
        return {
          ...order,
          payment_system: this.paymentSystems[order.payment_system] || order.payment_system,
          requisites_bank: order.requisites_info?.bank,
          requisites_recipient: order.requisites_info?.bank_recipient,
          requisites_country: order.requisites_info?.country,
          isCanFinish: this.finishAvailableStatuses.includes(order.status),
          isCanClaim: this.claimAvailableStatuses.includes(order.status),
          isCanCancelClaim: order.status === 'claim',
          isCanCancel: this.cancelAvailableStatuses.includes(order.status),
          txidLink: order.tx_id ? `https://live.blockcypher.com/${order.crypto_type.toLowerCase()}/tx/${order.tx_id}/` : '',
        };
      });
    },
    isDialogOpen() {
      return !!this.openDialog.id;
    },
    openDialogTitle() {
      let title = `Диалог по заявке №${this.openDialog.id}`;
      if (this.openDialog.deal_id) {
        title += ` (${this.openDialog.deal_id})`;
      }
      if (this.openDialog.handler) {
        title += ` (${this.openDialog.handler})`;
      }
      return title;
    },
    showResetSearchButton() {
      return (
          (this.searchMode === 'fiat_amount' &&
              (!!this.searchFiatAmount.min || !!this.searchFiatAmount.max)) ||
          (this.searchMode !== 'fiat_amount' && !!this.searchValue)
      );
    },
    isClientNoteAdding() {
      return !!this.clientNote.user;
    },
  },
  methods: {
    ...mapActions('orders', {
      loadOrdersList: LOAD_ORDERS_LIST,
      editOrder: EDIT_ORDER,
      finishOrder: FINISH_ORDER,
      refinishOrder: REFINISH_ORDER,
      cancelOrder: CANCEL_ORDER,
      openClaim: OPEN_CLAIM,
      cancelClaim: CANCEL_CLAIM,
      switchNote: SWITCH_NOTE,
    }),
    ...mapActions('exchange', {
      addBlackListUser: ADD_BLACK_LIST_USER,
      deleteBlackListUser: DELETE_BLACK_LIST_USER,
      addBlackListRequisite: ADD_BLACK_LIST_REQUISITE,
      deleteBlackListRequisite: DELETE_BLACK_LIST_REQUISITE,
      addUserNote: ADD_USER_NOTE,
      deleteUserNote: DELETE_USER_NOTE,
    }),
    startInterval() {
      this.intervalHandle = setInterval(() => this.loadOrders(this.page), 10000);
    },
    async loadOrders(page = 1, ignoreIsLoading = false) {
      if (this.isLoading && !ignoreIsLoading) {
        return;
      }
      const params = {
        page,
        per_page: this.per_page,
        active: this.activeMode,
      };
      if (this.searchValue) {
        params[this.searchMode] = this.searchValue;
      } else if (this.searchMode === 'fiat_amount') {
        if (this.searchFiatAmount.min) {
          params.fiat_amount_from = this.searchFiatAmount.min;
        }
        if (this.searchFiatAmount.max) {
          params.fiat_amount_to = this.searchFiatAmount.max;
        }
      }
      if (this.date) {
        params.from = this.dates.from;
        params.to = this.dates.to;
      }
      if (this.activeMode === 'finished') {
        params.finish_reason = this.finishReason;
      }
      await this.loadOrdersList({ params });
      this.page = page;
    },
    async searchOrders() {
      const needToReset =
          (this.searchMode === 'fiat_amount' &&
              !this.searchFiatAmount.min &&
              !this.searchFiatAmount.max) ||
          (this.searchMode !== 'fiat_amount' && !this.searchValue);
      if (needToReset) {
        this.resetSearch();
      } else {
        if (this.intervalHandle) {
          clearInterval(this.intervalHandle);
        }
        const currentTime = Date.now();
        this.searchInputLastActivatingTime = currentTime;
        setTimeout(() => {
          if (this.searchInputLastActivatingTime === currentTime) {
            this.searchValue = this.searchValue.trim();
            this.searchInputLastActivatingTime = 0;
            this.loadOrders(1, true);
            this.startInterval();
          }
        }, this.searchInputLoadDelay);
      }
    },
    resetSearch() {
      if (this.intervalHandle) {
        clearInterval(this.intervalHandle);
      }
      this.searchValue = '';
      this.searchFiatAmount.min = '';
      this.searchFiatAmount.max = '';
      this.searchInputLastActivatingTime = 0;
      this.loadOrders(1, true);
      this.startInterval();
    },
    updateDefaultSearchMode() {
      localStorage.setItem('orders_searchMode', this.searchMode);
      if (this.searchValue || this.searchFiatAmount.min || this.searchFiatAmount.max) {
        this.resetSearch();
      }
    },
    async openOrderModifying(id, amount, mode) {
      this.modifyingOrder.id = id;
      this.modifyingOrder.amount = amount;
      this.modifyingOrder.original_amount = amount;
      this.modifyingOrder.mode = mode;
      this.modifyingOrder.attachment_link = '';
      this.isOrderModifying = true;
    },
    async startModifyOrder() {
      const confirmMessage =
          this.modifyingOrder.mode === 'finish'
              ? `Вы уверены, что хотите завершить заявку №${this.modifyingOrder.id}?`
              : `Вы уверены, что хотите открыть претензию по заявке №${this.modifyingOrder.id}?`;
      this.$confirm(confirmMessage, 'Подтверждение')
          .then(async () => {
            const params = { id: this.modifyingOrder.id, data: { fiat_amount: parseInt(this.modifyingOrder.amount) } };
            if (this.modifyingOrder.mode === 'claim') {
              if (this.modifyingOrder.attachment_link) {
                if (!this.isValidURL(this.modifyingOrder.attachment_link)) {
                  return this.$message.warning('Адрес чека не валидный');
                }
                params.data.attachment_link = this.modifyingOrder.attachment_link;
              }
            }
            let request;
            if (this.modifyingOrder.mode === 'finish') {
              if (!this.modifyingOrder.finish_reason) {
                return this.$message.warning('Укажите причину завершения заявки');
              }
              if (!params.data) {
                params.data = {};
              }
              if (
                  this.modifyingOrder.finish_reason === 'compensation' ||
                  this.modifyingOrder.finish_reason === 'duplicate'
              ) {
                if (!this.modifyingOrder.compensation_order_id) {
                  return this.$message.warning('Укажите ID связной заявки');
                }
                params.data.compensation_order_id = this.modifyingOrder.compensation_order_id;
              }
              params.data.reason = this.modifyingOrder.finish_reason;
              request = await this.finishOrder(params);
            } else {
              request = await this.openClaim(params);
            }
            if (request.success) {
              const successMessage =
                  this.modifyingOrder.mode === 'finish'
                      ? 'Заявка успешно завершена'
                      : 'Претензия успешно открыта';
              this.$message.success(successMessage);
              this.resetOrderModifying();
            } else {
              this.$message.error(request.message || 'Неизвестная ошибка');
            }
          })
          .catch(() => {
            this.$message.info('Завершение отменено');
          });
    },
    async startCancelClaim(id) {
      this.$confirm('Вы уверены, что хотите отменить претензию?', 'Подтверждение')
          .then(async () => {
            const request = await this.cancelClaim({ id });
            if (request.success) {
              this.$message.success('Претензия отменена');
              this.resetOrderModifying();
            } else {
              this.$message.error(request.message || 'Неизвестная ошибка');
            }
          })
          .catch(() => {
            this.$message.info('Отменено');
          });
    },
    resetOrderModifying() {
      this.modifyingOrder.mode = '';
      this.modifyingOrder.id = null;
      this.modifyingOrder.amount = null;
      this.modifyingOrder.finish_reason = '';
      this.modifyingOrder.compensation_order_id = null;
      this.modifyingOrder.attachment_link = '';
      this.isOrderModifying = false;
    },
    startRefinishOrder(id) {
      this.$confirm('Вы уверены, что хотите отправить заявку на перезавершение?', 'Подтверждение')
          .then(async () => {
            const request = await this.refinishOrder(id);
            if (request.success) {
              this.$message.success('Успешно');
            } else {
              this.$message.error(`Ошибка: ${request.message || 'Неизвестная ошибка'}`);
            }
          })
          .catch(() => {
            this.$message.info('Отменено');
          });
    },
    async startCancelOrder(id) {
      this.$confirm('Вы уверены, что хотите отменить заявку?', 'Подтверждение')
          .then(async () => {
            const request = await this.cancelOrder({ id });
            if (request.success) {
              this.$message.success('Заявка успешно отменена');
            } else {
              this.$message.error(request.message || 'Неизвестная ошибка');
            }
          })
          .catch(() => {
            this.$message.info('Отменено');
          });
    },
    async changeBlackListStatus(value, mode = 'add', type = 'user') {
      const confirmMessage =
          mode === 'add'
              ? `Вы уверены, что хотите добавить ${type === 'user' ? 'пользователя' : 'реквизит'} ${value} в черный список?`
              : `Вы уверены, что хотите удалить ${type === 'user' ? 'пользователя' : 'реквизит'} ${value} из черного списка?`;
      this.$confirm(confirmMessage, 'Подтверждение')
          .then(async () => {
            let request = {};
            if (mode === 'add') {
              if (type === 'user') {
                request = await this.addBlackListUser({ value });
              } else {
                request = await this.addBlackListRequisite({ value });
              }
            } else {
              if (type === 'user') {
                request = await this.deleteBlackListUser(value);
              } else {
                request = await this.deleteBlackListRequisite(value);
              }
            }
            if (request.success) {
              this.$message.success('Успешно');
            } else {
              this.$message.error(`Ошибка: ${request.message || 'Неизвестная ошибка'}`);
            }
          })
          .catch(() => {
            this.$message.info('Отменено');
          });
    },
    async handleOrderNote(order, type) {
      const request = await this.switchNote({ id: order.id, type });
      if (request.success) {
        order.notes[type] = !order.notes[type];
      } else {
        this.$message.error(request.message || 'Неизвестная ошибка');
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.showClaimWarning) {
        return 'claim-warning'
      } else if (row.notes) {
        if (row.notes.paid) {
          return 'row-success';
        } else if (row.notes.problem) {
          return 'row-danger';
        }
      }
      return '';
    },
    copyIdInfo(order) {
      const deal_id = order.deal_id ? ` (${order.deal_id})` : '';
      const requisites = order.requisites ? `\n${order.requisites}` : '';
      const info = `${order.id}${deal_id}${requisites}`;
      this.copyTextToClipboard(info);
    },
    activateAddClientNote(client_name) {
      this.clientNote.user = client_name;
    },
    resetAddClientNote() {
      this.clientNote.user = '';
      this.clientNote.text = '';
    },
    async startAddClientNote() {
      const request = await this.addUserNote(this.clientNote);
      if (request.success) {
        this.$message.success('Заметка успешно добавлена');
        this.resetAddClientNote();
      } else {
        this.$message.error(`Ошибка добавления заметки: ${request.message}`);
      }
    },
    async startDeleteClientNote(client_name) {
      this.$confirm(`Вы уверены, что хотите удалить заметку клиента ${client_name}?`, 'Подтверждение').then(async () => {
        const request = await this.deleteUserNote(client_name);
        if (request.success) {
          this.$message.success('Заметка успешно удалена');
        } else {
          this.$message.error(`Ошибка удаления заметки: ${request.message}`);
        }
      }).catch(() => {
        this.$message.info('Удаление заметки отменено');
      });
    },
  },
};
</script>
<style scoped>
.messages__container {
  border: 1px solid lightgrey;
  padding: 5px;
  margin: 5px auto;
}

.requisite-add__buttons {
  margin-top: 10px;
}

.filters__container {
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #c9c9c9;
}

.search__container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-left: auto;
}

.search-reset__btn {
  padding: 11px;
  background-color: #e95050;
  cursor: pointer;
}

.search-reset__btn:hover {
  padding: 10px;
  background-color: #dd3636;
  border: 1px solid #850202;
}

.col-title {
  font-weight: 500;
  margin-right: 5px;
}

.order-action__buttons {
  display: flex;
}

.order-action__buttons .action__btn {
  margin: 0 1px;
  position: relative;
}

.action__btn .unread__badge {
  position: absolute;
  top: 0;
  left: 15px;
  width: 14px;
  height: 14px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dd4423;
  border-radius: 50%;
  background: #e6823c;
  color: white;
}

.dialog-action__buttons {
  display: flex;
  margin-bottom: 5px;
}

.dialog-action__buttons .action__btn {
  margin: auto 2px;
}

.original-amount {
  margin-bottom: 10px;
  font-weight: bold;
}

.search__container .el-select {
  width: 250px;
}

.order-black-list__btn {
  cursor: pointer;
  margin-left: 5px;
}

.black-list-user {
  color: #f56c6c;
  text-decoration: line-through;
}

.note-icon {
  cursor: pointer;
  margin: 0 2px;
  font-size: 20px;
  font-weight: bold;
}

.dates__container {
  display: flex;
  align-items: center;
}

.date__container {
  margin: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date__title {
  margin-right: 5px;
  font-size: 12px;
  font-weight: bold;
}

.finish-reason {
  margin: 5px auto;
}

.finish-reason-param {
  margin-bottom: 5px;
}

.order-id__container {
  cursor: pointer;
  font-size: 11px;
}

.table__container {
  position: relative;
}

.orders-loading-icon {
  color: #30d330;
  position: absolute;
  top: 5px;
  right: 20px;
  z-index: 9999999;
  font-size: 20px;
}

.search-fiat-amount {
  display: flex;
}

.client_note {
  font-style: italic;
  color: #991414;
  font-size: 13px;
}

.crypto-amount {
  font-size: 10px;
}

.claim-warning {
  background-color: red;
}
</style>
